/**
 * Sets the document <title> with the app's "AIKA - <page>" prefix.
 *
 * React 19 hoists <title> rendered anywhere in the tree to <head>, so this
 * replaces the old react-helmet-async `<Helmet titleTemplate="AIKA - %s">`
 * mechanism. Render it inside a page/route component.
 */
export default function PageTitle({ title }: { title?: string | null }) {
  return <title>{title ? `AIKA - ${title}` : "AIKA"}</title>;
}
